// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditNotificationModalContent-deleteButton-1D7CL Button-button-2PYOE Link-link-1rgM9","message":"EditNotificationModalContent-message-3Fn2V Alert-alert-e4rpV"};